module.exports = "/packs/media/images/Inheritance-0619135fc2f3b9d030c1077a8d80e9ea.png";